var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex text-center h-full bg-page",attrs:{"id":"app"}},[_c('Notify'),(_vm.isLoggedIn)?_c('AppNav',{on:{"logout":_vm.logout}}):_vm._e(),_c('div',{staticClass:"flex-1 overflow-y-auto"},[_c('router-view')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }